import React, { useEffect, useState } from 'react';
import Table from '../../shared/components/layout/Table';
import { transformData } from '../../super-admin/utils/transformData';
import { getPerformaInvoiceHistory } from '../services/api/implementation/impl';
import GridWrapper from '../../shared/components/layout/GridWrapper';
import NoDataFound from '../components/layout/NoDataFound';
import PaginationComponent from '../../shared/components/PaginationComponent';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import Header from '../../shared/components/layout/Header';
import Layout from '../components/layout/AppLayout';
// import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';
import Loader from '../../shared/components/ui/Loader';
import { useQuery } from '@tanstack/react-query';

const PerformaInvoiceHistory = () => {
  const { collapsed } = useSidebar();
  // pagination
  const [page, setPage] = useState(1);
  const [limit] = useState(10); // items per page

  const {
    data: PerformaInvoiceHistory,
    refetch: refetchPayablesHistory,
    isFetching: isFetchingPerformaInvoiceHistory
  } = useQuery({
    queryKey: ['performaInvoiceHistory', page],
    queryFn: () => getPerformaInvoiceHistory(page, limit),
    keepPreviousData: true
  });

  const totalPages = PerformaInvoiceHistory?.meta
    ? Math.ceil(PerformaInvoiceHistory?.meta.total / limit)
    : 1;

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    refetchPayablesHistory();
  }, []);

  // Removed blocks/levels fetching and useEffect

  const InvoiceFormat = ['id', 'name', 'project', 'bill_id', 'amount', 'created_at'];

  const PerformaInvoiceData = PerformaInvoiceHistory?.data?.map((item) =>
    transformData(
      {
        ...item,
        id: item.id,
        name: item?.quotation?.vendor?.user?.name,
        project: item?.project?.name,
        bill_id: item?.pi_id,
        amount: item?.paidAmount,
        created_at: item?.created_at
      },
      InvoiceFormat
    )
  );

  return (
    <>
      <Loader isVisible={isFetchingPerformaInvoiceHistory} />
      {/* Header */}

      <div className="w-full flex flex-col  z-5 bg-gray-100">
        {PerformaInvoiceData && PerformaInvoiceData?.length > 0 ? (
          <>
            {/* Grid */}

            <GridWrapper width={100} childrenCustomStyle="m-3">
              <div className="table-container mt-[8.5rem] h-[calc(100vh-11rem)]  overflow-auto border ">
                <style>{`
            .table-container .table-body {
              position: static !important;
              overflow-y: visible !important;
              max-height: none !important;
              height: auto !important;
              top: auto !important;
              padding-bottom: 0 !important;
            }
            .table-container .table-container {
              height: auto !important;  
            }
            .table-container > div {
              height: auto !important;
            }
          `}</style>
                <Table
                  headers={['Vendor Name', 'Project', 'PI ID', 'Amount', 'Date']}
                  data={PerformaInvoiceData}
                  identifier={'id'}
                  isViewEnable={false}
                  isEditEnable={false}
                  isDeleteEnable={false}
                  onDelete={() => {}}
                  isWrap={true}
                />
                <PaginationComponent
                  page={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  isFetching={isFetchingPerformaInvoiceHistory}
                />
              </div>
            </GridWrapper>
          </>
        ) : (
          <div className="pt-[3rem]">
            <NoDataFound disabledBtn screenHeight={true} />
          </div>
        )}
      </div>
    </>
  );
};

export default PerformaInvoiceHistory;
